import Grid from '@mui/material/Grid';
import Icon from '@mui/material/Icon';
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { useFormContext } from 'react-hook-form';
import { useState } from 'react';
import { useParams } from 'react-router';

import { ReactComponent as StripeIcon } from 'assets/stripe.svg';
import { useUpdateRenewInformationMutation } from 'store/api/version-api.slice';
import getFullname from 'utils/getFullname';

import PaymentErrors from '../PaymentErrors';

import UserPaymentFormWrapper from './UserPaymentFormWrapper';

const StripeCheckoutForm = ({ isRenewForm, plans, onSubmitHandler, paymentIntent }) => {
	const params = useParams();
	const { handleSubmit } = useFormContext();
	const [errors, setErrors] = useState();
	const [loading, setLoading] = useState(false);

	const stripe = useStripe();
	const elements = useElements();

	const [updatePaymentIntent] = useUpdateRenewInformationMutation();

	const resetErrors = () => setErrors(null);

	const onSubmit = async data => {
		if (!stripe || !elements) {
			// Stripe.js hasn't yet loaded.
			// Make sure to disable form submission until Stripe.js has loaded.
			return;
		}

		resetErrors();
		setLoading(true);

		const submitResult = await elements.submit();

		if (submitResult.error?.message) {
			setErrors(submitResult.error.message);
			setLoading(false);

			return;
		}

		const paymentMethodResult = await stripe.createPaymentMethod({
			elements,
			params: {
				billing_details: {
					name: getFullname({ firstname: data.first_name, lastname: data.last_name }),
					email: data.email
				}
			}
		});

		const result = await updatePaymentIntent({
			portalId: params.portal_id,
			contactId: params.contact_id,
			data: {
				member_type_id: data.plan_type,
				payment_intent_id: paymentIntent,
				payment_method_id: paymentMethodResult.paymentMethod.id
			}
		});

		if (result.data?.id) {
			resetErrors();
			await onSubmitHandler({ ...result.data, ...data, return_url: window.location.href, plans });
		} else {
			setErrors(result.error?.message);
		}

		setLoading(false);
	};

	return (
		<form id="payment-form" onSubmit={handleSubmit(onSubmit)}>
			<Icon sx={{ fontSize: '4rem', position: 'absolute', right: 20, top: 0 }}>
				<StripeIcon />
			</Icon>
			<UserPaymentFormWrapper isRenewForm={isRenewForm} loading={loading} plans={plans}>
				<Grid item xs={12}>
					<PaymentElement />
				</Grid>
				<Grid item xs={12}>
					<PaymentErrors errors={errors} />
				</Grid>
			</UserPaymentFormWrapper>
		</form>
	);
};

export default StripeCheckoutForm;
